export default __webpack_public_path__ + "static/media/upgrade-report4.6ce6cffc.png";